import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: "I was just fingerprinted last year. Why can't you just use those?",
    answer: 'Applicant prints are different from criminal prints and are only used for comparison in the criminal database. A new background check must be conducted for each new application. Results are sent from CJIS to the requesting agency. By law, prints are destroyed 90 days after collection.'
  }, {
    question: 'Can I just walk in?',
    answer: 'At this time, we do not accept walk-ins. Please use our online scheduler to book your appointment. Appointments are scheduled every 15 minutes.'
  }, {
    question: 'How much does it cost?',
    answer: 'When you contact us, the Fingerprint Technician will provide the exact fee based on the specific type of background check required.'
  }, {
    question: 'How long does it take?',
    answer: 'Processing typically takes 15-20 minutes. We operate first-come, first-served. Our office can open on weekends for groups of 5+ with advance notice.'
  }, {
    question: 'What are the hours of operation?',
    answer: 'Monday-Friday 7:00 AM - 7:00 PM, Saturdays 9:00 AM - 5:00 PM by appointment only. Check in 30 minutes before closing.'
  }, {
    question: 'How long for results?',
    answer: 'Wait at least 7 days before checking status. Typically 5-10 days for mail, 72 hours for the requesting agency. Contact MD Department of Public Safety at 410-764-4501 for status.'
  }, {
    question: 'How does it work?',
    answer: 'A technician scans your fingerprints and submits them electronically to CJIS, which forwards to the FBI. Takes about 15 minutes. Results in 2-7 business days sent directly to the requesting agency.'
  }, {
    question: 'What do I need to bring?',
    answer: "Two valid government-issued photo IDs (passport, driver's license, permanent resident card, or military ID). Plus any fingerprint paperwork from your employer. Minors must be accompanied by a legal parent with documentation."
  }, {
    question: 'How do I book an appointment?',
    answer: 'Visit our Book Appointment page, choose your service, pick a day and time, and complete the form. Or contact our customer service team directly.'
  }, {
    question: 'Do you do mobile fingerprinting for individuals?',
    answer: 'No. Mobile fingerprinting is available for groups of 3 or more. Book online or contact us to arrange mobile service.'
  }, {
    question: 'How long will mobile fingerprinting take?',
    answer: 'Each individual takes 10-15 minutes. Contact us ahead of time for larger groups to ensure enough time is allocated.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 bg-[#E7ECF8]" aria-labelledby="faq-heading" data-id="element-22">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <h2 id="faq-heading" className="text-3xl md:text-4xl font-bold text-[#1E1F55] mb-4" data-id="element-25">
            Frequently Asked Questions
          </h2>
          <div className="w-24 h-1 bg-[#4AA6CF] mx-auto rounded-full" aria-hidden="true" data-id="element-26"></div>
        </div>

        <div className="space-y-4" role="list" data-id="element-27">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" role="listitem" data-id="element-28">
              <h3 data-id="element-29">
                <button id={`faq-button-${index}`} onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex justify-between items-center" aria-expanded={openIndex === index} aria-controls={`faq-panel-${index}`} data-id="element-30">
                  <span className="font-bold text-[#1E1F55] pr-8" data-id="element-31">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 text-[#4AA6CF] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-32" />
                </button>
              </h3>

              <AnimatePresence initial={false} data-id="element-33">
                {openIndex === index && <motion.div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-button-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-34">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-35">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}